<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="form" label-width="40px" class="login-form">
      <h2>正科电机后台管理系统</h2>
      <el-form-item label="账号" prop="username">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" type="password" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleLogin">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { ElMessage } from 'element-plus'

const router = useRouter()
const authStore = useAuthStore()

const form = ref({
  username: '',
  password: ''
})

const loading = ref(false)

onMounted(() => {
  // 如果已经登录，重定向到首页
  if (authStore.isAuthenticated) {
    router.push('/categories')
  }
})

const handleLogin = async () => {
  loading.value = true
  try {
    // 调用登录方法
    await authStore.login(
      form.value.username,
      form.value.password
    )
    // 登录成功后重定向
    router.push('/categories')
  } catch (error) {
    ElMessage.error(error.message || '登录失败')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #6eb1ff 0%, #3a7bd5 50%, #00d2ff 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  top: -50px;
  right: -50px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
}

.login-container::after {
  content: '';
  position: absolute;
  bottom: -80px;
  left: -80px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}

.login-form {
  width: 100%;
  max-width: 420px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  z-index: 1;
  transition: all 0.3s ease;
}

.login-form:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
}

.login-form h2 {
  text-align: center;
  color: #2c3e50;
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 30px;
  letter-spacing: 0.5px;
}

.el-form-item__label {
  color: #34495e !important;
  font-weight: 500;
  padding-bottom: 8px;
}

.el-input__wrapper {
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
  transition: all 0.3s ease;
}

.el-input__wrapper:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12) !important;
}

.el-input__wrapper.is-focus {
  box-shadow: 0 4px 12px rgba(67, 94, 190, 0.25) !important;
}

.el-button {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(67, 94, 190, 0.3);
  margin-top: 10px;
}

.el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(67, 94, 190, 0.4);
}

.el-button:active {
  transform: translateY(0);
}

.demo-account {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
  margin-top: 25px;
  font-size: 13px;
  color: #7f8c8d;
  border-left: 3px solid #667eea;
}

.demo-account p {
  margin-bottom: 5px;
}


.demo-account strong {
  color: #2c3e50;
}

@media (max-width: 480px) {
  .login-form {
    padding: 30px 25px;
  }

  .login-form h2 {
    font-size: 24px;
  }
}
</style>